import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import { Link, withRouter } from 'react-router-dom'
import { media } from 'styled-bootstrap-grid'

import Some from '../Some'
import getRelativeUrl from 'utils/getRelativeUrl'


const OverlayNavItem = styled.div`
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 20px;

  && {
    transition-delay: ${props => 400 + (props.index * 150)}ms;
  }

  a {
    font-weight: 400;
    color: ${props => props.active ? props.theme.colors.primary : props.theme.colors.tones.darker};
  }

  ${props => props.active && css`
    >:first-child{
      border-bottom: 1px solid black;
    }
  `}

  ${props => props.highlighted && css`
  a{
    color: white !important;
    background-color: #00994c;
    padding: 1px 7px 1px 5px;
    border-radius: 25px;
    text-decoration: none;
  }

  `}
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 50px;

  > div {
    transform: translateX(${props => props.visible ? 0 : -50}%);
    opacity: ${props => props.visible ? 1 : 0};
    transition: all 400ms;
  }
`
const SomeContainer = styled.div`
width: 100%;
display: flex;

`

const SubMenu = styled.div`
  margin-left: 30px;
  margin-top: 10px;
  ${props => props.active && css`
  >:first-child{
    border-bottom: 1px solid black;
  }
`}

`

class Nav extends Component {
  static defaultProps = {
    indexOffset: 0
  }

  render() {
    const { visible, items, location, indexOffset } = this.props

    return (
      <Wrapper visible={visible}>
        {items.map((item, index) => (
          <OverlayNavItem
            index={index + indexOffset}
            key={item.id}
            active={getRelativeUrl(item.url) === location.pathname}
            highlighted={item.label === "Contact" || item.label === "Kontakt" || item.label === "Contacto" || item.label === "联系" ? 1 : 0}
          >
            <Link to={getRelativeUrl(item.url)}>{item.label}</Link>
            {item.childItems.map((child, index) => (
              <SubMenu
                index={index + indexOffset}
                key={child.id}
                active={getRelativeUrl(child.url) === location.pathname}
              >
                <Link to={getRelativeUrl(child.url)}>{child.label}</Link>
              </SubMenu>
            ))}
          </OverlayNavItem>))}
        {visible &&
          <SomeContainer
            key={"someContainer"}
            >
            <Some></Some>
          </SomeContainer>
        }

      </Wrapper>
    );
  }
}

export default withRouter(Nav)



// WEBPACK FOOTER //
// ./src/ui/components/Navigation/Overlay/Nav.js